/**
 * Retention shortcuts.
 */
import { Retention } from "../../features/analytics/retention";

export class RetentionTracker {
  constructor(public readonly client: Retention) {}

  /** Record that a user was active. */
  active(userId: string, properties?: Record<string, unknown>) {
    return this.client.trackActivity({ userId, properties });
  }
}
